/**
 * Created by Josef Jurca on 24/04/17.
 */
import {EditUserModalStatus, ActionTypes} from 'store/actions/modals/edituser';

/**
 * Status logic for state change.
 *
 * @param {Object} state - State of the component.
 * @param {Object} action - Payload for the action.
 * @returns {Object} Next state of the component.
 */
function status (state = EditUserModalStatus.INITIAL, action) {

    switch (action.type) {

        case ActionTypes.SET_EDIT_USER_MODAL_STATUS:
            return action.status;

        default:
            return state;
    }
}

/**
 * Form data logic for state change.
 *
 * @param {Object} state - State of the component.
 * @param {Object} action - Payload for the action.
 * @returns {Object} Next state of the component.
 */
function initialValues (state = {}, action) {
    switch (action.type) {

        case ActionTypes.SET_EDIT_USER_INITIAL_DATA:

            const userInitialValues = {...action.initialValues};

            if (userInitialValues.phone) {

                userInitialValues.phone = action.initialValues.phone.substring(3, action.initialValues.phone.length);
                userInitialValues.code = {
                      value: action.initialValues.phone.substring(0,3), label: action.initialValues.phone.substring(0,3) 
                }; 
            }
            return userInitialValues;

        default:
            return state;
    }
}

/**
 * Form data logic for state change.
 *
 * @param {Object} state - State of the component.
 * @param {Object} action - Payload for the action.
 * @returns {Object} Next state of the component.
 */
function formData (state = {}, action) {
    switch (action.type) {

        case ActionTypes.SET_EDIT_USER_DATA:
            if (action.formData.phone) {
                
                if(!action.formData.code) {
                    action.formData.phone = "050" + action.formData.phone
                } else {
                    action.formData.phone = action.formData.code.value ? action.formData.code.value + action.formData.phone : action.formData.code + action.formData.phone;
                }
            }
            return action.formData;

        default:
            return state;
    }
}

/**
 * Error logic for state change.
 *
 * @param {Object} state - State of the component.
 * @param {Object} action - Payload for the action.
 * @returns {Object} Next state of the component.
 */
function error (state = '', action) {
    switch (action.type) {

        case ActionTypes.SET_EDIT_USER_MODAL_ERROR:
            return action.error || '';

        default:
            return state;
    }
}

/**
 * Confirm reducer.
 *
 * @param {Object} state - State of the component.
 * @param {Object} action - Action payload.
 * @returns {Object} Confirm reducer.
 */
export default function setEditUserModal (state = {}, action) {

    return {
        status: status(state.status, action),
        initialValues: initialValues(state.initialValues, action),
        formData: formData(state.formData, action),
        error: error(state.error, action)
    };
}


// WEBPACK FOOTER //
// ./src/js/store/reducers/modals/edituser.js